import {
	BaseState,
	BaseStateSessionInfoCompany,
	BaseStateSessionInfoFlow,
	BaseStateSessionInfoGeoId,
} from './base.types';

export const initialBaseState: BaseState = {
	appSettings: {
		entryPointRoute: 'root',
	},
	sessionInfo: {
		interactionId: '',
		sessionId: '',
		tokenOAuth: '',
		alias: '',
		language: 'pt',
		company: BaseStateSessionInfoCompany.BCP,
		appMobile: true,
		mobileSystem: '',
		targetSystem: '',
		targetInfrastructure: '',
		accountList: [],
		geoId: BaseStateSessionInfoGeoId.Lisbon,
		flow: BaseStateSessionInfoFlow.Home,
		configs: {},
		ocpApimSubscriptionKey: '',
	},
};

export const baseReducer = (state = initialBaseState): BaseState => {
	return state;
};
